// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#resident-group-list[data-v-574812cc]{max-width:980px;margin-left:auto;margin-right:auto}#resident-group-list .title[data-v-574812cc]{font-size:22px;font-weight:700}#resident-group-list .add-btn[data-v-574812cc],#resident-group-list .back-btn[data-v-574812cc]{width:80px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
